import { ELECTRIC_CHART_LIST } from "../../constants/trendGraph/electricLines";
import { ADDITIONAL_ELECTRIC_TREND_LIST } from "../../constants/trendGraph/additionalElectricTrend";
import { SEP_CHART_LIST } from "../../constants/trendGraph/sepLines";
import { GRAPH_TYPE } from "../../constants/trendGraph/trendGraphType";
import localizationKeys from "../../i18n/localizationKeys";
import { ENGINE_CHART_LIST } from "./engine/engineList";

export const chartSettingList = (selectedGraph, isSepVessel = false) => {
  switch (selectedGraph) {
    case GRAPH_TYPE.ENGINE:
      return ENGINE_CHART_LIST;
    case GRAPH_TYPE.SEP:
      return SEP_CHART_LIST;
    case GRAPH_TYPE.ELECTRIC: {
      if(isSepVessel) {
        return ADDITIONAL_ELECTRIC_TREND_LIST
      }else {
        return ELECTRIC_CHART_LIST;
      }
    }
  }
};

const commonTabs = (t) => [
  {
    name: t(localizationKeys.EngineData_lower),
    id: GRAPH_TYPE.ENGINE,
  },
  {
    name: t(localizationKeys.SepData_lower),
    id: GRAPH_TYPE.SEP,
  },
  {
    name: t(localizationKeys.ElectricData_lower),
    id: GRAPH_TYPE.ELECTRIC,
  },
  {
    name: t(localizationKeys.Custom_lower),
    id: GRAPH_TYPE.CUSTOM,
  },
];

export const filterTabs = (isSepVessel, NoME, NoDG, NoSG, t) =>
  commonTabs(t)
    .filter((d) =>
      isSepVessel ? d.id !== GRAPH_TYPE.ENGINE : d.id !== GRAPH_TYPE.SEP
    ).filter(t => 
      (NoME > 0 && t.id === GRAPH_TYPE.ENGINE) || 
      ((NoDG > 0 || NoSG > 0) && t.id === GRAPH_TYPE.ELECTRIC) || 
      ([GRAPH_TYPE.SEP, GRAPH_TYPE.CUSTOM].includes(t.id))
    );